var React = require('react');

function RandomLocIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m13 0 3 3-3 3V4h-1.52l-3.2 4 3.2 4H13v-2l3 3-3 3v-2h-2.48L7 9.6 3.48 14H0v-2h2.52l3.2-4-3.2-4H0V2h3.48L7 6.4 10.52 2H13V0z","fill":"#fff"}));
}

RandomLocIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = RandomLocIcon;

RandomLocIcon.default = RandomLocIcon;
